/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 12/01/2025
 * @update 12/01/2025
 * @file src/components/W17/W17F2180
 */

import { Button, ButtonIcon, Checkbox, Col, DatePicker, Dropdown, Label, Popover, PopoverBody, Row, Typography, Modal, ModalBody, ModalHeader } from 'diginet-core-ui/components';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../actions/user-actions";
import Config from "../../config";
import EventTracking from "../common/tracking/event";
import { Column } from "devextreme-react/data-grid";
import { makeStyles } from "diginet-core-ui/theme";
import * as W17F2180Actions from "../../actions/w17/w17F2180/w17F2180-actions";
import GridContainer from "../common/grid-container/grid-container";
import { Loading } from "../common/loading/loading";
import W17F2180Jobs from "./W17F2180_jobs";
import { browserHistory } from "react-router";
import SendMail from "../W17/W17F1002";

const FormID = 'W17F2180';

const useStyles = makeStyles((theme) => ({
    popAction: {
        minWidth: 196,
        padding: theme.spacing([2, 0, 2, 0])
    },
    btnActionItem: {
        display: 'flex',
        width: '100%',
        justifyContent: 'start',
        color: theme.colors.primary
    },
    colGridLeft: {
        height: '100%',
        [theme.breakpoints.up('md')]: {
            borderRight: `1px solid ${theme?.colors?.line?.system}`,
        },
    },
    divScroll: {
        paddingRight: '1px',
        height: 'calc(100vh - 254px)',
        overflow: 'auto',
        [theme.breakpoints.down('md')]: {
            height: '100%',
            overflow: 'inherit',
        },
    },
    divBottom: {
        padding: theme.spacing(6),
        marginLeft: -theme.spacing(6),
        marginRight: '-15px',
        boxShadow: `0px -1px 0px ${theme?.colors?.line?.system}`,
        position: "relative",
    },
}));

const W17F2180 = (props) => {
    const { dataCboEmployee } = props;
    const classes = useStyles();
    const [formLoading, setFormLoading] = useState(false);
    const [grid01Loading, setGrid01Loading] = useState(false);
    const [grid02Loading, setGrid02Loading] = useState(false);
    const [btnJobsStatus, setBtnJobsStatus] = useState(true); // default Disable Btn Phân Tuyến
    const [btnCloseJobsStatus, setBtnCloseJobsStatus] = useState(true); // default Disable Btn Hủy Phân Tuyến
    const [cboEmployeeLoading, setCboEmployeeLoading] = useState(false);
    const [openW17F2180Jobs, setOpenW17F2180Jobs] = useState(false);
    const [cboStrCustomerLoading, setCboStrCustomerLoading] = useState(false);
    const [openSendMail, setOpenSendMail] = useState(false);
    const [iPermission, setIPermission] = useState(null);
    const [grid02Mode, setGrid02Mode] = useState('edit');
    const [error, setError] = useState({});
    const [dataStrCustomer, setDataStrCustomer] = useState([]);
    const [dataMaster, setDataMaster] = useState({
        StrEmployeeID: '',
        StrCustomerID: '',
        JobsDate: Config.convertDate(new Date())
    });
    const [dataGrid01, setDataGrid01] = useState([]);
    const [dataGrid02, setDataGrid02] = useState([]);

    const grid01Ref = useRef(null);
    const grid02Ref = useRef(null);
    const gridContainerRef = useRef(null);
    const popMore01Ref = useRef(null);
    const currentRowClick = useRef({});

    useEffect(() => {
        loadPermission();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!iPermission) return;
        loadGrid(1);
        if (Config.isEmpty(dataCboEmployee)) loadCboEmployee();
        loadStrCustomer();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission]);

    const loadPermission = () => {
        props.userActions.getPermission(Config.profile.UserID, FormID, (isPer) => {
            setIPermission(isPer);
        })
    };

    const loadCboEmployee = () => {
        setCboEmployeeLoading(true);
        props.W17F2180Actions.loadCboEmployee((error) => {
            setCboEmployeeLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            }
        })
    };

    const loadStrCustomer = () => {
        const { EmployeeID = '' } = currentRowClick.current;
        const params = {
            EmployeeID
        };
        setCboStrCustomerLoading(true);
        props.W17F2180Actions.loadStrCustomer(params, (error, data) => {
            setCboStrCustomerLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataStrCustomer(data || []);
            }
        });
    };

    const updateEmployeeStatus = (dataRow, mode) => {
        let label = '';
        let DataType = '';
        if (mode === 'clock') {
            DataType = 'DisableEMP';
            label = Config.lang('Dong_tai_khoan');
        }
        if (mode === 'unClock') {
            DataType = 'EnableEMP';
            label = Config.lang('Mo_tai_khoan');
        }
        const { EmployeeID = '' } = dataRow || {};
        const params = {
            DataType,
            EmployeeID
        };
        setCboStrCustomerLoading(true);
        props.W17F2180Actions.updateEmployeeStatus(params, (error, data) => {
            setCboStrCustomerLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) {
                    handleActionSuccess(label);
                } else {
                    if (data?.Message) Config.popupCore.show('INFO', data.Message);
                }
            }
        });
    };

    const loadGrid = (grid, dataRow = currentRowClick.current, isView = false) => {
        let DataType = '';
        let EmployeeID = '';
        const { EmployeeID: employeeID = '' } = dataRow || {};
        const { StrEmployeeID = '', StrCustomerID = '' } = dataMaster;
        if (grid === 1) {
            DataType = 'LoadFromEmp';
            setGrid01Loading(true);
        } else if (grid === 2) {
            DataType = 'LoadFromCus';
            EmployeeID = employeeID;
            setGrid02Loading(true);
            setBtnJobsStatus(true); // Disable Btn Phân Tuyến
            setGrid02Mode(isView ? 'view' : 'edit');
        }
        const params = {
            DataType,
            EmployeeID,
            StrEmployeeID,
            StrCustomerID
        };
        props.W17F2180Actions.loadGrid(params, (error, data) => {
            if (grid === 1) setGrid01Loading(false);
            if (grid === 2) setGrid02Loading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (grid === 1) {
                    setDataGrid01(data || []);
                    const currentPage = gridContainerRef.current.getRefPaging().instance.option('currentPage');
                    if (currentPage > 0) grid01Ref.current.instance.pageIndex(currentPage);
                }
                else if (grid === 2) {
                    loadStrCustomer();
                    setDataGrid02(data || []);
                    if (!isView) setBtnCloseJobsStatus(false); // Enable Btn Huy
                }
            }
        });
    };

    const handleActionSuccess = (label = '') => {
        currentRowClick.current = {};
        setBtnCloseJobsStatus(true) // Disabled Btn
        loadGrid(1); // Load lại lưới 
        setDataGrid02([]); // Clear lưới 2
        if (!Config.isEmpty(label)) Config.popupCore.show('INFO', Config.lang(`%${label}%_thanh_cong`));
    };

    const closeJobs = () => {
        const { EmployeeID = '' } = currentRowClick.current;
        const { JobsDate = null } = dataMaster;
        if (Config.isEmpty(JobsDate)) return handleError();
        const params = {
            EmployeeID,
            JobsTime: JobsDate
        };
        setFormLoading(true);
        props.W17F2180Actions.closeJobs(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) {
                    handleActionSuccess();
                } else {
                    if (data?.Message) Config.popupCore.show('INFO', data.Message);
                }
            }
        });
    };

    const renderCheckBoxColumn = (e, name = '') => {
        if (!e) return '';
        return <Checkbox
            readOnly={grid02Mode === 'view'}
            style={{ margin: 'auto' }}
            className={'display_row align-center'}
            checked={e?.value === 1}
            onChange={(c) => {
                e.component.cellValue(e.rowIndex, name, +c?.value);
                e.component.saveEditData();
                const dataSource = e.component.option('dataSource');
                setBtnJobsStatus(dataSource.findIndex(item => !!item?.IsMultiple) < 0);
            }}
        />;
    };

    const onChange = (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        let value = e?.value ?? e?.target?.value ?? '';
        if (['JobsDate'].includes(fieldName) && Config.isEmpty(value)) value = null;
        if (fieldName === 'JobsDate') currentRowClick.current.JobsDate = value;
        setDataMaster({ ...dataMaster, [fieldName]: value });
        if (error[fieldName] && !Config.isEmpty(value)) {
            setError({ ...error, [fieldName]: '' });
        }
    };

    const onList = (data) => {
        if (Config.isEmpty(data)) return null;
        browserHistory.push({
            pathname: Config.getRootPath() + 'W17F2181',
            state: {
                EmployeeID: data?.EmployeeID || '',
                Permission: iPermission
            }
        });
    };

    const handleBtnActionClick = (data) => {
        if (data) currentRowClick.current = data;
        if (popMore01Ref.current) popMore01Ref.current.close();
    };

    const renderAction = (e, grid) => {
        let btnArr = {};
        const rowData = e?.data || {};
        const { Isclose } = rowData;
        switch (grid) {
            case 1:
                btnArr = [{
                    label: Config.lang('Phan_tuyen'),
                    startIcon: 'Mapping',
                    onClick: () => {
                        handleBtnActionClick(rowData);
                        loadGrid(2, rowData);
                    }
                },
                {
                    label: Config.lang('Danh_sach_tuyen'),
                    startIcon: 'ListAlt',
                    onClick: () => {
                        if (popMore01Ref.current) popMore01Ref.current.close();
                        onList(rowData);
                    }
                },
                {
                    label: Config.lang('Dong_tai_khoan'),
                    startIcon: 'Lock',
                    disabled: Isclose === 1,
                    onClick: () => {
                        handleBtnActionClick(rowData);
                        updateEmployeeStatus(rowData, 'clock');
                    }
                },
                {
                    label: Config.lang('Mo_tai_khoan'),
                    startIcon: 'Unlock',
                    disabled: Isclose === 0,
                    onClick: () => {
                        handleBtnActionClick(rowData);
                        updateEmployeeStatus(rowData, 'unClock');
                    }
                },
                {
                    label: Config.lang('Thong_tin_hoat_dong'),
                    startIcon: 'Info',
                    disabled: true, // Chưa xử lý
                    onClick: () => { }
                }];
                break;
            case 2:
                btnArr = [{
                    label: Config.lang('Xem_lich_su_vien_tham'),
                    startIcon: 'History',
                    disabled: true, // Chưa xử lý
                    onClick: () => { }
                },
                {
                    label: Config.lang('Xem_vi_tri_tren_ban_do'),
                    startIcon: 'Marker',
                    disabled: true, // Chưa xử lý
                    onClick: () => { }
                },];
                break;
            default:
                break;
        }
        return (
            <Popover {...(grid === 1 ? { ref: e => popMore01Ref.current = e } : {})}
                anchor={<ButtonIcon
                    viewType={'ghost'}
                    name={'Menu'}
                />}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}>
                <PopoverBody className={classes.popAction}>
                    {btnArr.map(item => (
                        <Button
                            viewType={'text'}
                            color={'info'}
                            labelProps={{ style: { textTransform: 'capitalize' } }}
                            className={classes.btnActionItem}
                            startIcon={item.startIcon}
                            label={item.label}
                            onClick={item.onClick}
                            disabled={!!item?.disabled}
                        />))}
                </PopoverBody>
            </Popover>
        );
    }

    const handleError = () => {
        setError({ ...error, JobsDate: Config.lang('Truong_nay_bat_buoc_nhap') })
        return Config.popupCore.show('INFO', `${Config.lang('Vui_long_nhap_day_du_thong_tin')} ${Config.lang('Ngay_phan_tuyen').toLowerCase()}`);
    };

    const getDataSource = async (grid) => {
        let dataSource = [];
        if (grid === 1) {
            await grid01Ref.current.instance.saveEditData();
            dataSource = grid01Ref.current.instance.option('dataSource') || [];
        } else if (grid === 2) {
            await grid02Ref.current.instance.saveEditData();
            dataSource = grid02Ref.current.instance.option('dataSource') || [];
        }
        return dataSource;
    };

    const handleOpenW17F2180Jobs = async (status, isSave = false) => {
        const { JobsDate } = dataMaster;
        if (Config.isEmpty(JobsDate) && status) return handleError();
        if (!!status) {
            let CustomerIDArr = [];
            const dataSource = await getDataSource(2);
            for (let i = 0; i < dataSource.length; i++) {
                const { CustomerID = '', IsMultiple } = dataSource[i];
                if (!!IsMultiple) CustomerIDArr.push(CustomerID);
            }
            currentRowClick.current.CustomerIDArr = CustomerIDArr || [];
        }
        setOpenW17F2180Jobs(status);
        if (isSave) handleActionSuccess(Config.lang('Phan_tuyen'));
    };

    const renderGrid01 = useMemo(() => {
        return (
            <GridContainer
                reference={ref => (grid01Ref.current = ref)}
                ref={ref => (gridContainerRef.current = ref)}
                dataSource={dataGrid01}
                isPer={iPermission}
                loading={grid01Loading}
                keyExpr={'EmployeeID'}
                typePaging={'normal'}
                itemPerPage={30}
                listPerPage={[30, 60, 90, 120]}
                height={Config.getHeightGrid() - 102}
                onCellClick={(e) => {
                    if (e.columnIndex === 0) return;
                    currentRowClick.current = { ...currentRowClick.current, ...e?.data };
                    loadGrid(2, currentRowClick.current, true);
                }}>
                <Column
                    cellRender={(e) => renderAction(e, 1)}
                    caption={Config.lang('Hanh_dong')}
                    alignment={'center'}
                    allowEditing={false}
                    allowSorting={false}
                    fixed={true}
                    width={100}
                />
                <Column
                    dataField={'EmployeeID'}
                    caption={Config.lang('Ma_nhan_vien')}
                    width={160}
                />
                <Column
                    dataField={'EmployeeName'}
                    caption={Config.lang('Ten_nhan_vien')}
                    width={240}
                />
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataGrid01, grid01Loading]);

    const renderGrid02 = useMemo(() => {
        const dataSource = dataGrid02.map((item, idx) => ({ ...item, STT: idx }));
        return (
            <GridContainer
                reference={ref => (grid02Ref.current = ref)}
                dataSource={dataSource}
                isPer={iPermission}
                loading={grid02Loading}
                keyExpr={'STT'}
                typePaging={'normal'}
                itemPerPage={30}
                height={Config.getHeightGrid() - 420}
                editing={{
                    mode: 'cell',
                    refreshMode: 'reshape',
                    allowUpdating: grid02Mode === 'edit',
                    texts: { confirmDeleteMessage: '' },
                    startEditAction: 'click',
                }}
            >
                <Column
                    cellRender={(e) => renderAction(e, 2)}
                    caption={Config.lang('Hanh_dong')}
                    alignment={'center'}
                    allowEditing={false}
                    allowSorting={false}
                    fixed={true}
                    width={100}
                />
                <Column
                    width={90}
                    allowEditing={false}
                    alignment={'center'}
                    dataField={'IsMultiple'}
                    caption={Config.lang('Chon')}
                    cellRender={(e) => renderCheckBoxColumn(e, 'IsMultiple')}
                />
                <Column
                    allowEditing={false}
                    dataField={'CustomerID'}
                    caption={Config.lang('Ma_nhan_vien')}
                    width={160}
                />
                <Column
                    allowEditing={false}
                    dataField={'CustomerName'}
                    caption={Config.lang('Ten_nhan_vien')}
                    width={240}
                />
                <Column
                    allowEditing={false}
                    dataField={'Adress'}
                    caption={Config.lang('Vi_tri')}
                    width={180}
                />
                <Column
                    allowEditing={false}
                    dataField={'Coordinates'}
                    caption={Config.lang('Toa_do')}
                    width={180}
                />
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataGrid02, grid02Loading, grid02Mode]);

    if (!iPermission) return null;
    return (
        <div className='page-container'>
            {formLoading && <Loading />}
            <EventTracking action={'FORM'} label={FormID} />
            <Row>
                {openW17F2180Jobs && <W17F2180Jobs open={openW17F2180Jobs} handleOpen={(status, isSave) => handleOpenW17F2180Jobs(status, isSave)} dataInfo={{ ...currentRowClick.current, ...dataMaster }} />}
                {openSendMail && <Modal
                    open
                    size={'md'}
                    onClose={() => setOpenSendMail(false)} >
                    <ModalHeader>{Config.lang('Gui_mail')}</ModalHeader>
                    <ModalBody><SendMail data={{ FormID }} onHide={() => setOpenSendMail(false)} /></ModalBody>
                </Modal>}
                <Col xs={12}><Typography color={'info'} type={'h4'}>{Config.lang('Quan_tri_DMS')}</Typography></Col>
                <Col xs={12} sm={12} md={12} lg={4}>
                    <Row>
                        <Col xs={12} verticalAlign={'center'}>
                            <div className={'full_w display_row align-center'}>
                                <Typography hoverTooltip lineClamp={1} type={'h4'}>{Config.lang('Nhan_vien')}</Typography>
                                <Dropdown
                                    clearAble
                                    className={'mgl4x'}
                                    viewType={'outlined'}
                                    valueExpr={'StrEmployeeID'}
                                    displayExpr={'StrEmployeeName'}
                                    loading={cboEmployeeLoading}
                                    inputStyle={{ minWidth: 200 }}
                                    value={dataMaster?.StrEmployeeID}
                                    dataSource={dataCboEmployee || []}
                                    onChange={e => onChange('StrEmployeeID', e)}
                                />
                                <Button
                                    color={'primary'}
                                    className={'mgl4x'}
                                    startIcon={'Search'}
                                    viewType={'outlined'}
                                    label={Config.lang('Tim_kiem')}
                                    onClick={() => loadGrid(1)}
                                />
                                <Button
                                    color={'primary'}
                                    className={'mgl4x'}
                                    startIcon={'Mail'}
                                    viewType={'outlined'}
                                    label={Config.lang('Gui_mail')}
                                    onClick={() => setOpenSendMail(true)}
                                />
                            </div>
                        </Col>
                        <Col xs={12} className={`${classes.colGridLeft} mgt4x pdt0`}>{renderGrid01}</Col>
                    </Row>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8}>
                    <Row>
                        <Col xs={12} verticalAlign={'center'}>
                            <div className={'full_w display_row align-center'}>
                                <Typography hoverTooltip lineClamp={1} type={'h4'}>{Config.lang('Khach_hang')}</Typography>
                                <Dropdown
                                    clearAble
                                    className={'mgl4x'}
                                    viewType={'outlined'}
                                    valueExpr={'StrCustomerID'}
                                    displayExpr={'StrCustomerName'}
                                    loading={cboStrCustomerLoading}
                                    inputStyle={{ minWidth: 200 }}
                                    value={dataMaster?.StrCustomerID}
                                    dataSource={dataStrCustomer || []}
                                    onChange={e => onChange('StrCustomerID', e)}
                                />
                                <Button
                                    color={'primary'}
                                    className={'mgl4x'}
                                    startIcon={'Search'}
                                    viewType={'outlined'}
                                    label={Config.lang('Tim_kiem')}
                                    onClick={() => loadGrid(2)}
                                />
                            </div>
                        </Col>
                        <Col xs={12} className={classes.divScroll}>{renderGrid02}</Col>
                        <Col xs={12}>
                            <div className={`display_row align-between ${classes.divBottom}`}>
                                <div className={'display_row align-center'}>
                                    <Label required type={'h4'}>{Config.lang('Ngay_phan_tuyen')}</Label>
                                    <DatePicker
                                        clearAble
                                        useDateInput
                                        className={'mgl4x'}
                                        viewType={'outlined'}
                                        displayFormat={"DD/MM/YYYY"}
                                        error={error && error['JobsDate']}
                                        value={dataMaster.JobsDate}
                                        onChange={e => onChange('JobsDate', e)}
                                    />
                                </div>
                                <div>
                                    <Button
                                        color={'danger'}
                                        viewType={'filled'}
                                        disabled={btnCloseJobsStatus}
                                        label={Config.lang('Huy')}
                                        onClick={() => closeJobs()}
                                    />
                                    <Button
                                        color={'primary'}
                                        viewType={'filled'}
                                        className={"mgl2x"}
                                        disabled={btnJobsStatus}
                                        label={Config.lang('Phan_tuyen')}
                                        onClick={() => handleOpenW17F2180Jobs(true)}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
}

export default connect(state => ({
    dataCboEmployee: state?.w17f2180?.dataCboEmployee || [],
}), (dispatch) => ({
    W17F2180Actions: bindActionCreators(W17F2180Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W17F2180);


